import Api from "@/helpers/api";
import indexedDB from "@/helpers/IndexedDB";

export default {
  methods: {
    loginApi(firebaseResult) {
      let userInfo = firebaseResult.user;

      const data = {
        username: this.email,
        uuid: userInfo.uid,
        client_secret: this.clientSecret
      };

      Api.post("/auth/login", data)
        .then(result => {
          let uuid = result.data.uuid ? result.data.uuid : null;
          this.getDataUser(result, uuid);
        })
        .catch(error => console.error("loginApi error", error))
        .finally(() => this.$vs.loading.close());
    },
    loginSessionCheck(token, company_id) {
      Api.get(`/auth/connect/${token}/${company_id}`)
        .then(result => {
          this.$store
            .dispatch("firebaseAuth/loginAnonimus")
            .then(resultFirebase => {
              let uuid = resultFirebase.user.uid ? resultFirebase.user.uid : null;
              this.getDataUser(result, uuid);
            })
            .catch(error => {
              console.error("firebaseAuth/loginAnonimus error", error);
              this.showNotify();
              this.redirectonFail();
            });
        })
        .catch(error => {
          console.error("/auth/connect error", error);
          this.showNotify();
          this.redirectonFail();
        });
    },
    async getDataUser(result, uuid) {
      if (uuid !== null) {
        try {          
          this.$store.commit("SET_SESSION_TOKEN", result.data.accessToken); 
          const dataUser = await Api.get(`/users/${result.data.userID}`);
          const newDataUser = {...result.data, ...dataUser.data};
          await indexedDB.put("users", newDataUser, uuid);
          const user = this._mapUser([newDataUser]);         
          delete user[0].accessToken;
          delete user[0].expireToken;
          delete user[0].tokenType;
          this.$store.commit("SET_DATA_USER", user[0]);
          this.$acl.change(result.data.roleName.toLowerCase());
          this.$router.push("/dashboard/analytics");
          this.updateLocale(user[0].localeName);
        } catch (error) {
          console.error("indexedDB PUT error:", error);
        }       
      } else {
        console.warn("loginApi uuid error");
      }
    },
    _mapUser(data) {
      return data.map(user => {
        return {
          ...user,
          uuid: user.uuid,
          name: user.name,
          lastname: user.lastname,
          image: user.picture,
          roleID: user.roleID,
          roleName: user.roleName,
          address: user.address,
          cellPhone: user.cellPhone,
          companyID: user.companyID,
          companyName: user.companyName,
          email: user.email,
          features: user.features,
          cityID: user.cityID,
          departmentID: user.departmentID,
          key: user.key,
          username: user.username,
          localeID: user.localeID
        };
      });
    },
    updateLocale(locale) {
      const data = {
        spanish: 'es',
        english: 'en',
        'portugués': 'pt',
        french: 'fr'
      }
      
      this.$i18n.locale = data[locale];
    }
  }
};
